import React from 'react';

import { Grid } from '@material-ui/core';

import { Section } from 'components/Section';


export function ChartsGrid(props: {
  title: string,
  charts: React.ReactNode[],
}) {
  return (
    <Section title={props.title}>
      <Grid container spacing={3}>
        {props.charts.map((c, i) => (
          <Grid item key={i} xs={6}>
            {c}
          </Grid>
        ))}
      </Grid>
    </Section>
  );
}